import { u as useAsync, _ as _objectWithoutProperties } from './ZapSharingProvider-9b241926.esm.js';
export { A as AccountAndProfileProvider, Z as ZapSharingProvider, a as useAccountAndProfile, u as useAsync } from './ZapSharingProvider-9b241926.esm.js';
export { P as PostEnableModal } from './PostEnableModal-a63b494e.esm.js';
export { B as BORDER_RADIUS, F as FALLBACK_PRIMARY_COLOR, M as MAX_WIDTH_SHARED_ZAP_LANDER_CONTENT, a as MOBILE_BREAKPOINT } from './constants-30ac82a8.esm.js';
import { u as useBoolean, g as getAppImplementations, a as useSize } from './ZapSharingModalContainer-8092f18b.esm.js';
export { D as DivergenceAlert, E as ErrorsModal, M as ModalFix, P as PartnersContactEmail, S as SpinnerButton, l as StatusBadge, Z as ZapSharingModal, k as addTruthyParamsToUrl, f as createEditorUrl, i as formatInviteOnlyApps, j as getFatalErrors, h as hasDisabledSharing, u as useBoolean, b as useOriginDivergenceState, a as useScreenSize, e as useUpdateGuidedRecipeStatus, c as useUpdateSharedZap, d as useZtStatus } from './ZapSharingModalContainer-8092f18b.esm.js';
export { Z as ZapTemplateAppBar } from './ZapTemplateAppBar-a847c342.esm.js';
export { default as DeleteSharedZapModal } from '../DeleteSharedZapModal/dist/sharing.esm.js';
export { g as getPluralType, t as toFlow, u as useSharedZap } from './SharedZapUtils-84797084.esm.js';
import { u as useWindowSize } from './MaybeZapSharingTeamAndCompanyDashboard-4f410018.esm.js';
export { M as MaybeTeamAndCompanyDashboard, a as ModalCloseButton, u as useWindowSize } from './MaybeZapSharingTeamAndCompanyDashboard-4f410018.esm.js';
export { u as useLocalStorage } from './useLocalStorage-805f8b1b.esm.js';
import { u as usePrevious } from './usePrevious-87d1ecab.esm.js';
export { u as usePrevious } from './usePrevious-87d1ecab.esm.js';
import { _ as _objectSpread2 } from './objectSpread2-cdde903d.esm.js';
import * as React from 'react';
import React__default, { useState, useRef, useMemo, useLayoutEffect, useEffect, Fragment } from 'react';
import { compact, get, omit, uniq, isNull, isUndefined, clamp } from 'lodash';
import { fetchJson } from '@zapier/toolbox-browser-fetch';
import { useQuery } from '@apollo/react-hooks';
import pluralizer from 'pluralize';
export { N as NamedTrackingProvider, e as extractParams, u as useNamedTracking } from './SharingButton-d57d6560.esm.js';
import { css } from '@emotion/react';
import { labelStyles, isolateComponent } from '@zapier/style-encapsulation';
import { IconButton, Indicator } from '@zapier/design-system';
export { M as MaybeSharingLinkNotification } from './MaybeSharingLinkNotification-0c7c4d00.esm.js';
import { useSwitch } from '@zapier/toolbox-ab-testing';
import '@zapier/identity';
import 'uuid';
import '@zapier/toolbox-tracking';
import '@apollo/react-common';
import 'memoize-weak';
import '@zapier/design-system-patterns';
import '@zapier/date';
import '@zapier/cookies';
import 'querystring';

const getInviteOnlyApps = services => {
  const appsWithoutServices = compact(services).filter(service => !!service.id && !service.slug);
  return appsWithoutServices.map(app => app.name ? app.name : app.id);
};

const pluralize = (noun, number) => {
  return pluralizer(noun, number);
};

const useZTFeatures = ({
  isDeveloper,
  accountId
}) => {
  const {
    isSwitchOn: isZTCreatorSwitchOn,
    isLoading: isLoadingCreatorSwitch
  } = useSwitch('sharing_new_zt_creator', accountId);
  const {
    isSwitchOn: isGlobalSwitchOn,
    isLoading: isLoadingGlobalSwitch
  } = useSwitch('sharing_global_sharing_enabled', accountId);
  const isLoading = isLoadingCreatorSwitch || isLoadingGlobalSwitch;
  const areBothSwitchesOn = isZTCreatorSwitchOn && isGlobalSwitchOn;
  const shouldUseZtFeatures = !isLoading && isDeveloper && areBothSwitchesOn;
  return {
    isLoading,
    shouldUseZtFeatures
  };
};

const AppsBySlugQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "appsBySlug"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "slugs"
        }
      },
      "type": {
        "kind": "ListType",
        "type": {
          "kind": "NonNullType",
          "type": {
            "kind": "NamedType",
            "name": {
              "kind": "Name",
              "value": "String"
            }
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "appsBySlug"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "slugs"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "slugs"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "currentImplementation"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "id"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "slug"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "name"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "description"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "image"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "primaryColor"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "canonicalId"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 221,
    "source": {
      "body": "\n  query appsBySlug($slugs: [String!]) {\n    appsBySlug(slugs: $slugs) {\n      currentImplementation {\n        id\n      }\n      slug\n      name\n      description\n      image\n      primaryColor\n      canonicalId\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

const useGetAppsBySlug = ({
  slugs
}) => {
  const {
    data,
    loading: areAppsLoading
  } = useQuery(AppsBySlugQuery, {
    variables: {
      slugs
    },
    skip: slugs.length === 0
  });
  return {
    areAppsLoading,
    apps: (data === null || data === void 0 ? void 0 : data.appsBySlug) || []
  };
};

const suggestedZapTemplatesQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "suggestedZapTemplatesQuery"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "limit"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "appCanonicalIds"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "ListType",
          "type": {
            "kind": "NonNullType",
            "type": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "String"
              }
            }
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "suggestedZapTemplates"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "personalizeBy"
          },
          "value": {
            "kind": "EnumValue",
            "value": "popularity"
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "limit"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "limit"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "appCanonicalIds"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "appCanonicalIds"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "edges"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "zapTemplate"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "id"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "editorUrl"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "title"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "headService"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "image"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "primaryColor"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "tailService"
                    },
                    "arguments": [],
                    "directives": [],
                    "selectionSet": {
                      "kind": "SelectionSet",
                      "selections": [{
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "name"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "image"
                        },
                        "arguments": [],
                        "directives": []
                      }, {
                        "kind": "Field",
                        "name": {
                          "kind": "Name",
                          "value": "primaryColor"
                        },
                        "arguments": [],
                        "directives": []
                      }]
                    }
                  }]
                }
              }]
            }
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 514,
    "source": {
      "body": "\n  query suggestedZapTemplatesQuery($limit: Int!, $appCanonicalIds: [String!]!) {\n    suggestedZapTemplates(\n      personalizeBy: popularity\n      limit: $limit\n      appCanonicalIds: $appCanonicalIds\n    ) {\n      edges {\n        zapTemplate {\n          id\n          editorUrl\n          title\n          headService {\n            name\n            image\n            primaryColor\n          }\n          tailService {\n            name\n            image\n            primaryColor\n          }\n        }\n      }\n    }\n  }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

const useSuggestedZapTemplates = ({
  limit,
  appCanonicalIds
}) => {
  const {
    data,
    loading,
    error
  } = useQuery(suggestedZapTemplatesQuery, {
    variables: {
      limit,
      appCanonicalIds
    }
  });
  const templates = get(data, ['suggestedZapTemplates', 'edges'], []);
  const ZTs = compact(templates.map(zt => zt.zapTemplate));
  return {
    data: ZTs,
    loading,
    error
  };
};

function usePublicZapAsync() {
  const _useAsync = useAsync(),
        {
    run
  } = _useAsync,
        state = _objectWithoutProperties(_useAsync, ["run"]);

  const [hasFetched, markAsFetched] = useBoolean();
  const previousData = usePrevious(state.data);
  const fetchPublicZap = React.useCallback((linkHash, params) => {
    run(fetchJson(`/api/v3/zaps/shared/${linkHash}${params}`).then(publicZap => {
      markAsFetched();
      return publicZap;
    }));
  }, [markAsFetched, run]);
  const isRefetching = hasFetched && state.isIdleOrLoading;
  const data = isRefetching ? previousData : state.data;
  return _objectSpread2(_objectSpread2({}, state), {}, {
    fetchPublicZap,
    isRefetching,
    data
  });
}

function usePublicZapStepTitlesAsync() {
  const _useAsync2 = useAsync(),
        {
    run
  } = _useAsync2,
        state = _objectWithoutProperties(_useAsync2, ["run"]);

  const fetchPublicZapStepTitles = React.useCallback((linkHash, params) => {
    run(fetchJson(`/api/v3/zaps/shared/${linkHash}/step-titles${params}`).then(data => data.step_titles).catch(() => []));
  }, [run]);
  return _objectSpread2(_objectSpread2({}, state), {}, {
    fetchPublicZapStepTitles
  });
}

const usePublicZap = (linkHash, accountId) => {
  const {
    fetchPublicZap,
    data: publicZap,
    isIdle,
    isIdleOrLoading: isPublicZapLoading,
    error: publicZapError,
    isRefetching
  } = usePublicZapAsync();
  const {
    fetchPublicZapStepTitles,
    data: stepTitles,
    isIdleOrLoading: isStepTitlesLoading
  } = usePublicZapStepTitlesAsync();
  const params = React.useMemo(() => {
    return accountId !== 0 ? `?account_id=${accountId}` : '';
  }, [accountId]);
  const refetchPublicZap = React.useCallback(() => {
    fetchPublicZap(linkHash, params);
  }, [fetchPublicZap, params, linkHash]);
  React.useEffect(() => {
    // For many zaps, we don't require authentication if the user has the shared zap link.
    // For that reason, most first requests for the shared zap
    // (without the account id, since it could be loading)
    // will succeed. Once the account ID loads, if the last request was successful,
    // we don't want to needlessly re-request the SZ. Otherwise, weird loading states will ensue.
    if (isIdle) {
      fetchPublicZap(linkHash, params);
      fetchPublicZapStepTitles(linkHash, params);
    }
  }, [accountId, fetchPublicZap, fetchPublicZapStepTitles, params, isIdle, linkHash]);
  const publicZapWithStepTitles = React.useMemo(() => {
    if (publicZap === undefined || stepTitles === undefined) {
      return undefined;
    }

    const stepsWithTitles = publicZap.guided_recipe.steps.map((step, i) => _objectSpread2(_objectSpread2({}, step), {}, {
      title: stepTitles[i]
    }));

    const zapWithStepTitles = _objectSpread2(_objectSpread2({}, publicZap), {}, {
      guided_recipe: _objectSpread2(_objectSpread2({}, publicZap.guided_recipe), {}, {
        steps: stepsWithTitles
      })
    });

    return zapWithStepTitles;
  }, [publicZap, stepTitles]);
  return {
    publicZap: publicZapWithStepTitles,
    isPublicZapLoading: isPublicZapLoading || isStepTitlesLoading,
    publicZapError: publicZapError !== undefined ? publicZapError.message : undefined,
    refetchPublicZap,
    isRefetching
  };
};

const useAppImplementations = ({
  ids
}) => {
  const {
    run,
    data: appImplementations,
    isLoading: areAppImplementationsLoading,
    isIdle
  } = useAsync();
  React.useEffect(() => {
    if (ids.length && isIdle) {
      run(getAppImplementations(ids));
    }
  }, [ids, isIdle, run]);
  return {
    areAppImplementationsLoading,
    appImplementations
  };
};

const chooseTruthyProperties = (obj1, obj2) => {
  const obj1Keys = Object.keys(omit(obj1, '__typename'));
  const obj2Keys = Object.keys(omit(obj2, '__typename'));
  const allKeys = uniq(obj1Keys.concat(obj2Keys));

  if (obj1 && obj2) {
    const serviceWithTruthiestKeys = allKeys.reduce((service, key) => {
      if (obj1.hasOwnProperty(key) && !isNull(obj1[key]) && !isUndefined(obj1[key])) {
        return _objectSpread2(_objectSpread2({}, service), {}, {
          [key]: obj1[key]
        });
      } else {
        const obj2Key = obj2[key];
        const maybeString = isNull(obj2Key) || isUndefined(obj2Key) ? '' : obj2[key];
        return _objectSpread2(_objectSpread2({}, service), {}, {
          [key]: maybeString
        });
      }
    }, {});
    return serviceWithTruthiestKeys;
  }

  return _objectSpread2(_objectSpread2({}, obj1), obj2);
};

const usePublicZapWithServices = ({
  accountId,
  guid
}) => {
  const {
    publicZap,
    isPublicZapLoading,
    publicZapError,
    refetchPublicZap,
    isRefetching
  } = usePublicZap(guid, accountId); // we want to memoize here so that dependent queries
  // do not refetch data when we just refetch the
  // shared Zap data

  const {
    slugs,
    steps,
    selectedApis
  } = React.useMemo(() => {
    var _publicZap$guided_rec;

    const _slugs = compact(publicZap === null || publicZap === void 0 ? void 0 : publicZap.service_slugs);

    const _steps = compact(publicZap === null || publicZap === void 0 ? void 0 : (_publicZap$guided_rec = publicZap.guided_recipe) === null || _publicZap$guided_rec === void 0 ? void 0 : _publicZap$guided_rec.steps);

    const _selectedApis = _steps.map(step => step.selected_api);

    return {
      slugs: _slugs,
      steps: _steps,
      selectedApis: _selectedApis
    };
  }, [publicZap]);
  const {
    apps,
    areAppsLoading
  } = useGetAppsBySlug({
    slugs
  });
  const {
    areAppImplementationsLoading,
    appImplementations
  } = useAppImplementations({
    ids: selectedApis
  });
  const isAppDataLoading = React.useMemo(() => areAppsLoading || areAppImplementationsLoading, [areAppImplementationsLoading, areAppsLoading]);
  const isLoading = React.useMemo(() => isPublicZapLoading || isAppDataLoading, [isAppDataLoading, isPublicZapLoading]); // same here, memoizing to ensure that we're only regenerating
  // the full app info array when the actual apps or app implementations
  // are loading/ready

  const fullAppInfo = React.useMemo(() => isAppDataLoading ? [] : appImplementations === null || appImplementations === void 0 ? void 0 : appImplementations.map(impl => {
    const correspondingApp = apps.find(app => {
      var _app$currentImplement;

      return ((_app$currentImplement = app.currentImplementation) === null || _app$currentImplement === void 0 ? void 0 : _app$currentImplement.id) === impl.id;
    });
    const allInfo = chooseTruthyProperties(impl, correspondingApp);
    return allInfo;
  }), [appImplementations, apps, isAppDataLoading]); // this seems to be the most critical to preventing the
  // re-fetching of extra data when we only refetch the shared
  // zap data

  const servicesInOrder = React.useMemo(() => isAppDataLoading ? undefined : compact(steps.map(step => (fullAppInfo === null || fullAppInfo === void 0 ? void 0 : fullAppInfo.find(app => app.id === step.selected_api)) || {
    id: step.selected_api
  })), [fullAppInfo, isAppDataLoading, steps]);
  const hasInviteOnlyApps = React.useMemo(() => (publicZap === null || publicZap === void 0 ? void 0 : publicZap.service_slugs.some(slug => !slug)) || (fullAppInfo === null || fullAppInfo === void 0 ? void 0 : fullAppInfo.some(app => app.isPrivateOnly)) || false, [fullAppInfo, publicZap]);
  return {
    services: servicesInOrder,
    // when the user is logged out, we won't get any private app implementation
    // data at all. So in that case we should just assume that if some of the slugs
    // in the shared zap object are null, there are most likely private apps in it.
    hasInviteOnlyApps,
    isLoading,
    publicZap,
    error: publicZapError,
    refetchPublicZap,
    isRefetching
  };
};

const MOCK_SHARED_ZAP = {
  id: 197186,
  zuid: '5fb6c5cc-3f81-43dd-8979-f472dc63fa10',
  creator: {
    id: 6207302,
    name: 'Brian Wendt',
    gravatar_url: 'https://secure.gravatar.com/avatar/577df6761dec9acdc04cc744e1e45d0c.jpg?s=80&amp;r=g'
  },
  account_id: 6208772,
  link_hash: '1b0d33bd9d009cfcb7701a811a76bf7e91e2ec83',
  service_slugs: ['slack', 'google-sheets'],
  title: 'Slack to Google Sheets',
  description: 'Anytime a reaction is created in Slack, add row lines in Google Sheets',
  state: 'private',
  origin_divergence_state: 'synced',
  node_id: 105054384,
  is_node_paused: false,
  guided_recipe: {
    id: 387598,
    date: '2020-11-19T19:21:49+00:00',
    lastchanged: '2021-03-03T13:04:12+00:00',
    canonical_id: '53cd76f0-1068-42a2-beb8-f7f453bc88fe',
    title: 'Slack to Google Sheets',
    slug: 'slack-to-google-sheets',
    description: 'Anytime a reaction is created in Slack, add row lines in Google Sheets',
    status: 'community',
    head_service: {
      title: 'Slack',
      slug: 'slack'
    },
    tail_service: {
      title: 'Google Sheets',
      slug: 'google-sheets'
    },
    used: 1,
    template_root_node: null,
    added_by: {
      id: 6207302
    },
    steps: [{
      id: 1,
      type_of: 'read',
      type: 'node',
      params: {},
      meta: {},
      parent_id: null,
      root_id: null,
      action: 'reaction',
      selected_api: 'SlackAPI',
      overrides: {}
    }, {
      id: 2,
      type_of: 'write',
      type: 'node',
      params: {},
      meta: {},
      parent_id: 1,
      root_id: 1,
      action: 'add_row_lines',
      selected_api: 'GoogleSheetsV2API',
      overrides: {}
    }]
  },
  _invite_only_apps: []
};

const tracked = {};

function createCallback(track, targets) {
  return entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const entryId = entry.target.id;
        const key = `#${entryId}`;
        const component_name = targets[key];

        if (component_name !== undefined && !tracked[key]) {
          track({
            component_name,
            action_name: 'in_view'
          });
          tracked[key] = true;
        }
      }
    });
  };
}

function observeInView(track, targets) {
  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };
  const targetElements = Object.keys(targets).map(id => document.querySelector(id));
  const observer = new IntersectionObserver(createCallback(track, targets), options);
  targetElements.forEach(target => {
    if (target) {
      observer.observe(target);
    }
  });
}

// calculate current item width and screen size
// handle offset for children

const useCarouselPagination = ({
  numberOfItems
}) => {
  const [currentIndex, updateIndex] = useState(0);

  const moveRight = () => {
    const nextIndex = currentIndex + 1;
    updateIndex(clamp(nextIndex, 0, numberOfItems - 1));
  };

  const moveLeft = () => {
    const nextIndex = currentIndex - 1;
    updateIndex(clamp(nextIndex, 0, numberOfItems - 1));
  };

  const goToIndex = index => {
    updateIndex(index);
  };

  const canMoveLeft = currentIndex >= 1;
  const canMoveRight = currentIndex < numberOfItems - 2;
  return {
    canMoveLeft,
    canMoveRight,
    currentIndex,
    goToIndex,
    moveLeft,
    moveRight
  };
};

const useDraggingPagination = ({
  moveRight,
  moveLeft
}) => {
  const [isDragging, toggleDragging] = useState(false);
  const [startX, setStartX] = useState(0);

  const startDragging = e => {
    const startPosX = e.targetTouches[0].clientX;
    setStartX(startPosX);
    toggleDragging(true);
  };

  const stopDragging = e => {
    const endPosX = e.changedTouches[0].clientX;
    const delta = !endPosX ? 0 : startX - endPosX;

    if (delta > 20) {
      moveRight();
    } else if (delta < -20) {
      moveLeft();
    }

    setStartX(0);
    toggleDragging(false);
  };

  return {
    startDragging,
    stopDragging,
    isDragging
  };
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Styles = labelStyles('Carousel', {
  root: process.env.NODE_ENV === "production" ? {
    name: "pw7jst",
    styles: "position:relative;width:100%"
  } : {
    name: "so3hg7-root",
    styles: "position:relative;width:100%;label:root;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
    toString: _EMOTION_STRINGIFIED_CSS_ERROR__
  },
  items: leftOffset => /*#__PURE__*/css({
    display: 'flex',
    left: leftOffset,
    position: 'relative',
    transition: 'left .3s',
    transitionTimingFunction: 'ease-in-out',
    width: 'fit-content',
    zIndex: 1
  }, process.env.NODE_ENV === "production" ? "" : ";label:Styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"),
  arrowButtonContainer: side => {
    return /*#__PURE__*/css({
      position: 'absolute',
      top: 'calc(((100% - 90px) / 2) - 20px)',
      [side]: '8%',
      zIndex: 3
    }, process.env.NODE_ENV === "production" ? "" : ";label:Styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNhcm91c2VsLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFrQ1ciLCJmaWxlIjoiQ2Fyb3VzZWwudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3ggaXNvbGF0ZUNvbXBvbmVudCAqL1xuaW1wb3J0IFJlYWN0LCB7XG4gIFJlYWN0RWxlbWVudCxcbiAgdXNlTWVtbyxcbiAgRnJhZ21lbnQsXG4gIHVzZVN0YXRlLFxuICB1c2VFZmZlY3QsXG4gIHVzZUxheW91dEVmZmVjdCxcbiAgdXNlUmVmLFxufSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBpc29sYXRlQ29tcG9uZW50LCBsYWJlbFN0eWxlcyB9IGZyb20gJ0B6YXBpZXIvc3R5bGUtZW5jYXBzdWxhdGlvbic7XG5pbXBvcnQgeyBJY29uQnV0dG9uLCBJbmRpY2F0b3IgfSBmcm9tICdAemFwaWVyL2Rlc2lnbi1zeXN0ZW0nO1xuaW1wb3J0IHVzZUNhcm91c2VsUGFnaW5hdGlvbiBmcm9tICcuL3VzZUNhcm91c2VsUGFnaW5hdGlvbic7XG5pbXBvcnQgeyB1c2VTY3JlZW5TaXplLCB1c2VXaW5kb3dTaXplLCB1c2VQcmV2aW91cyB9IGZyb20gJy4uLy4uL2hvb2tzJztcblxuaW1wb3J0IHVzZURyYWdnaW5nUGFnaW5hdGlvbiBmcm9tICcuL3VzZURyYWdnaW5nUGFnaW5hdGlvbic7XG5cbmNvbnN0IFN0eWxlcyA9IGxhYmVsU3R5bGVzKCdDYXJvdXNlbCcsIHtcbiAgcm9vdDogY3NzKHtcbiAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICB3aWR0aDogJzEwMCUnLFxuICB9KSxcbiAgaXRlbXM6IChsZWZ0T2Zmc2V0OiBudW1iZXIpID0+XG4gICAgY3NzKHtcbiAgICAgIGRpc3BsYXk6ICdmbGV4JyxcbiAgICAgIGxlZnQ6IGxlZnRPZmZzZXQsXG4gICAgICBwb3NpdGlvbjogJ3JlbGF0aXZlJyxcbiAgICAgIHRyYW5zaXRpb246ICdsZWZ0IC4zcycsXG4gICAgICB0cmFuc2l0aW9uVGltaW5nRnVuY3Rpb246ICdlYXNlLWluLW91dCcsXG4gICAgICB3aWR0aDogJ2ZpdC1jb250ZW50JyxcbiAgICAgIHpJbmRleDogMSxcbiAgICB9KSxcbiAgYXJyb3dCdXR0b25Db250YWluZXI6IChzaWRlOiAnbGVmdCcgfCAncmlnaHQnKSA9PiB7XG4gICAgcmV0dXJuIGNzcyh7XG4gICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgIHRvcDogJ2NhbGMoKCgxMDAlIC0gOTBweCkgLyAyKSAtIDIwcHgpJyxcbiAgICAgIFtzaWRlXTogJzglJyxcbiAgICAgIHpJbmRleDogMyxcbiAgICB9KTtcbiAgfSxcbiAgaW5kaWNhdG9yQ29udGFpbmVyOiAoaXNTbWFsbDogYm9vbGVhbikgPT5cbiAgICBjc3Moe1xuICAgICAgYWxpZ25JdGVtczogJ2NlbnRlcicsXG4gICAgICBkaXNwbGF5OiAnZmxleCcsXG4gICAgICBoZWlnaHQ6IGlzU21hbGwgPyA3MCA6IDkwLFxuICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxuICAgICAgbWFyZ2luOiAnMCBhdXRvJyxcbiAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgIH0pLFxufSk7XG5cbnR5cGUgUHJvcHMgPSB7XG4gIGNoaWxkcmVuOiBSZWFjdEVsZW1lbnQ8YW55PiB8IEFycmF5PFJlYWN0RWxlbWVudDxhbnk+PjtcbiAgb25DaGFuZ2U/OiAoaW5kZXg6IG51bWJlciwgcHJldmlvdXNJbmRleD86IG51bWJlcikgPT4gdm9pZDtcbiAgcmVuZGVySGVhZGluZz86ICh7XG4gICAgY3VycmVudEluZGV4LFxuICB9OiB7XG4gICAgY3VycmVudEluZGV4OiBudW1iZXI7XG4gICAgbnVtYmVyT2ZJdGVtczogbnVtYmVyO1xuICB9KSA9PiBSZWFjdEVsZW1lbnQ8YW55Pjtcbn07XG5cbmNvbnN0IENhcm91c2VsID0gKHsgY2hpbGRyZW4sIG9uQ2hhbmdlLCByZW5kZXJIZWFkaW5nIH06IFByb3BzKSA9PiB7XG4gIGNvbnN0IFt3aW5kb3dXaWR0aF0gPSB1c2VXaW5kb3dTaXplKCk7XG4gIGNvbnN0IHNpemUgPSB1c2VTY3JlZW5TaXplKCk7XG4gIGNvbnN0IFtpdGVtT2Zmc2V0LCBzZXRJdGVtT2Zmc2V0XSA9IHVzZVN0YXRlKDApO1xuICBjb25zdCBbbWFyZ2luLCBzZXRNYXJnaW5dID0gdXNlU3RhdGUoMCk7XG4gIGNvbnN0IFtjYXJvdXNlbENoaWxkV2lkdGgsIHNldENhcm91c2VsQ2hpbGRXaWR0aF0gPSB1c2VTdGF0ZSgwKTtcbiAgY29uc3QgY2Fyb3VzZWwgPSB1c2VSZWY8SFRNTFVMaXN0RWxlbWVudD4obnVsbCk7XG4gIGNvbnN0IGNhcm91c2VsQ29udGFpbmVyID0gdXNlUmVmPEhUTUxEaXZFbGVtZW50PihudWxsKTtcbiAgY29uc3QgbnVtYmVyT2ZJdGVtcyA9IFJlYWN0LkNoaWxkcmVuLmNvdW50KGNoaWxkcmVuKTtcbiAgY29uc3QgcGFyZW50V2lkdGggPVxuICAgIGNhcm91c2VsQ29udGFpbmVyLmN1cnJlbnQ/LnBhcmVudEVsZW1lbnQ/LmdldEJvdW5kaW5nQ2xpZW50UmVjdCgpLndpZHRoIHx8XG4gICAgMDtcbiAgY29uc3Qge1xuICAgIGNhbk1vdmVMZWZ0LFxuICAgIGNhbk1vdmVSaWdodCxcbiAgICBjdXJyZW50SW5kZXgsXG4gICAgbW92ZVJpZ2h0LFxuICAgIG1vdmVMZWZ0LFxuICAgIGdvVG9JbmRleCxcbiAgfSA9IHVzZUNhcm91c2VsUGFnaW5hdGlvbih7XG4gICAgbnVtYmVyT2ZJdGVtcyxcbiAgfSk7XG4gIGNvbnN0IHByZXZpb3VzSW5kZXggPSB1c2VQcmV2aW91cyhjdXJyZW50SW5kZXgpO1xuICBjb25zdCB7IHN0YXJ0RHJhZ2dpbmcsIHN0b3BEcmFnZ2luZywgaXNEcmFnZ2luZyB9ID0gdXNlRHJhZ2dpbmdQYWdpbmF0aW9uKHtcbiAgICBtb3ZlUmlnaHQsXG4gICAgbW92ZUxlZnQsXG4gIH0pO1xuXG4gIGNvbnN0IGNoaWxkcmVuV2l0aElkID0gdXNlTWVtbyhcbiAgICAoKSA9PlxuICAgICAgUmVhY3QuQ2hpbGRyZW4ubWFwKGNoaWxkcmVuLCAoY2hpbGQsIGkpID0+IHtcbiAgICAgICAgY29uc3QgaXNOZXh0ID0gY3VycmVudEluZGV4ID09PSBpIC0gMTtcbiAgICAgICAgY29uc3QgaXNQcmV2aW91cyA9IGN1cnJlbnRJbmRleCA9PT0gaSArIDE7XG4gICAgICAgIGNvbnN0IGlzQ3VycmVudCA9IGN1cnJlbnRJbmRleCA9PT0gaTtcbiAgICAgICAgY29uc3Qgb3BhY2l0eSA9XG4gICAgICAgICAgaXNQcmV2aW91cyB8fCBjdXJyZW50SW5kZXggPT09IGkgLSAyXG4gICAgICAgICAgICA/ICcuNidcbiAgICAgICAgICAgIDogaXNDdXJyZW50IHx8IGlzTmV4dFxuICAgICAgICAgICAgPyAnMSdcbiAgICAgICAgICAgIDogJzAnO1xuXG4gICAgICAgIGNvbnN0IHZpc2liaWxpdHkgPVxuICAgICAgICAgIGlzTmV4dCB8fCBpc1ByZXZpb3VzIHx8IGlzQ3VycmVudCB8fCBjdXJyZW50SW5kZXggPT09IGkgLSAyXG4gICAgICAgICAgICA/ICd2aXNpYmxlJ1xuICAgICAgICAgICAgOiAnaGlkZGVuJztcbiAgICAgICAgcmV0dXJuIFJlYWN0LmNsb25lRWxlbWVudChjaGlsZCwge1xuICAgICAgICAgIHN0eWxlOiB7XG4gICAgICAgICAgICB2aXNpYmlsaXR5LFxuICAgICAgICAgICAgb3BhY2l0eSxcbiAgICAgICAgICAgIHRyYW5zaXRpb246ICdvcGFjaXR5IC4zcywgdmlzaWJpbGl0eSAuM3MnLFxuICAgICAgICAgICAgdHJhbnNpdGlvblRpbWluZ0Z1bmN0aW9uOiAnZWFzZS1pbi1vdXQnLFxuICAgICAgICAgICAgd2lkdGg6IGNhcm91c2VsQ2hpbGRXaWR0aCxcbiAgICAgICAgICAgIG1hcmdpbjogYDAgJHttYXJnaW59cHhgLFxuICAgICAgICAgICAgZGlzcGxheTogJ2ZsZXgnLFxuICAgICAgICAgICAganVzdGlmeUNvbnRlbnQ6ICdjZW50ZXInLFxuICAgICAgICAgIH0sXG4gICAgICAgIH0pO1xuICAgICAgfSksXG4gICAgW2Nhcm91c2VsQ2hpbGRXaWR0aCwgY2hpbGRyZW4sIGN1cnJlbnRJbmRleCwgbWFyZ2luXVxuICApO1xuXG4gIC8vIHNlZSBpZiB3ZSBjYW4gY2FsY3VsYXRlIHNpemVzIGJlZm9yZSBwYWludGluZ1xuICB1c2VMYXlvdXRFZmZlY3QoKCkgPT4ge1xuICAgIGlmIChcbiAgICAgIGNhcm91c2VsQ29udGFpbmVyLmN1cnJlbnQgIT09IG51bGwgJiZcbiAgICAgIGNhcm91c2VsLmN1cnJlbnQgIT09IG51bGwgJiZcbiAgICAgIHdpbmRvd1dpZHRoICYmXG4gICAgICAhaXNEcmFnZ2luZ1xuICAgICkge1xuICAgICAgY29uc3QgY2FyZFdpZHRoQXNQZXJjZW50YWdlV2lkdGhPZkNvbnRhaW5lciA9IHNpemUuaXNTbWFsbCA/IDAuOCA6IDAuMjg7XG5cbiAgICAgIGNvbnN0IHRhcmdldENoaWxkV2lkdGggPVxuICAgICAgICBwYXJlbnRXaWR0aCAqIGNhcmRXaWR0aEFzUGVyY2VudGFnZVdpZHRoT2ZDb250YWluZXI7XG4gICAgICBjb25zdCBtYXJnaW5QZXJjZW50YWdlID0gc2l6ZS5pc1NtYWxsID8gMSA6IDAuMDU7XG4gICAgICAvLyBjYWxjdWxhdGUgdGhlIHJlbWFuaW5nIHNwYWNlIHdlIGhhdmUgaW4gdGhlIGNvbnRhaW5lclxuICAgICAgLy8gYWZ0ZXIgdGhlIGNoaWxkIHdpZHRoIGhhcyBiZWVuIGNhbGN1bGF0ZWQsIGdldCB0aGUgZGVzaXJlZCBtYXJnaW4gcGVyY2VudGFnZSBzaXplLFxuICAgICAgLy8gYW5kIGRpdmlkZSBieSAyIHRvIGdldCBtYXJnaW4gcGVyIHNpZGVcbiAgICAgIGNvbnN0IHRhcmdldENoaWxkTWFyZ2luID1cbiAgICAgICAgKChwYXJlbnRXaWR0aCAtIHRhcmdldENoaWxkV2lkdGgpICogbWFyZ2luUGVyY2VudGFnZSkgLyAyO1xuICAgICAgLy8gdGhlIGZpcnN0IHR3byBjYXJkcyBzaG91bGQgYmUganVzdCBsZWZ0IGFuZCByaWdodCBvZiBjZW50ZXJcbiAgICAgIC8vIHNvIGdldCB0aGUgY2VudGVyIG9mIHRoZSBwYXJlbnQgY29udGFpbmVyIGJ5IGRpdmlkaW5nIGJ5IDIsXG4gICAgICAvLyB0aGVuIHN1YnRyYWN0IHRoZSBtYXJnaW5cbiAgICAgIGNvbnN0IHN0YXJ0aW5nT2Zmc2V0ID0gc2l6ZS5pc1NtYWxsXG4gICAgICAgID8gMFxuICAgICAgICA6IHBhcmVudFdpZHRoIC8gMiAtICh0YXJnZXRDaGlsZFdpZHRoICsgdGFyZ2V0Q2hpbGRNYXJnaW4gKiAyKTtcbiAgICAgIC8vIGRlcGVuZGluZyBvbiB3aGljaCBjYXJkIHdlJ3JlIG9uLCBjYWxjdWxhdGUgdGhlIG51bWJlciBvZiBwb2ludHNcbiAgICAgIC8vIHRvIG1vdmUgdGhlIGNvbnRlbnQgbGVmdCBvciByaWdodFxuICAgICAgY29uc3Qgb2Zmc2V0ID1cbiAgICAgICAgc3RhcnRpbmdPZmZzZXQgLVxuICAgICAgICAodGFyZ2V0Q2hpbGRXaWR0aCArIHRhcmdldENoaWxkTWFyZ2luICogMikgKiBjdXJyZW50SW5kZXg7XG4gICAgICBzZXRJdGVtT2Zmc2V0KG9mZnNldCk7XG4gICAgICBzZXRNYXJnaW4odGFyZ2V0Q2hpbGRNYXJnaW4pO1xuICAgICAgc2V0Q2Fyb3VzZWxDaGlsZFdpZHRoKHRhcmdldENoaWxkV2lkdGgpO1xuICAgIH1cbiAgfSwgW1xuICAgIGNhcm91c2VsLFxuICAgIGNhcm91c2VsQ29udGFpbmVyLFxuICAgIGN1cnJlbnRJbmRleCxcbiAgICBpc0RyYWdnaW5nLFxuICAgIHBhcmVudFdpZHRoLFxuICAgIHNpemUuaXNTbWFsbCxcbiAgICB3aW5kb3dXaWR0aCxcbiAgXSk7XG5cbiAgLy8gbm90aWZ5IG9mIGEgY2hhbmdlIGluIGluZGV4XG4gIHVzZUVmZmVjdCgoKSA9PiB7XG4gICAgaWYgKG9uQ2hhbmdlKSB7XG4gICAgICBvbkNoYW5nZShjdXJyZW50SW5kZXgsIHByZXZpb3VzSW5kZXgpO1xuICAgIH1cbiAgfSwgW2N1cnJlbnRJbmRleCwgb25DaGFuZ2UsIHByZXZpb3VzSW5kZXhdKTtcblxuICBjb25zdCBzaG91bGRTaG93SW5kaWNhdG9yID0gc2l6ZS5pc1NtYWxsIHx8IG51bWJlck9mSXRlbXMgPiAyO1xuICByZXR1cm4gKFxuICAgIDxGcmFnbWVudD5cbiAgICAgIHt0eXBlb2YgcmVuZGVySGVhZGluZyA9PT0gJ2Z1bmN0aW9uJyAmJlxuICAgICAgICByZW5kZXJIZWFkaW5nKHsgY3VycmVudEluZGV4LCBudW1iZXJPZkl0ZW1zIH0pfVxuICAgICAgPGRpdiBjc3M9e1N0eWxlcy5yb290fSByZWY9e2Nhcm91c2VsQ29udGFpbmVyfT5cbiAgICAgICAgeyFzaXplLmlzU21hbGwgJiYgbnVtYmVyT2ZJdGVtcyA+IDIgJiYgKFxuICAgICAgICAgIDxGcmFnbWVudD5cbiAgICAgICAgICAgIDxkaXYgY3NzPXtTdHlsZXMuYXJyb3dCdXR0b25Db250YWluZXIoJ2xlZnQnKX0+XG4gICAgICAgICAgICAgIDxJY29uQnV0dG9uXG4gICAgICAgICAgICAgICAgYXJpYUxhYmVsPVwicHJldmlvdXMgc3RlcFwiXG4gICAgICAgICAgICAgICAgY29sb3I9XCJpY29uLXByaW1hcnlcIlxuICAgICAgICAgICAgICAgIGRpc2FibGVkPXshY2FuTW92ZUxlZnR9XG4gICAgICAgICAgICAgICAgaWNvbj17J2Fycm93U21hbGxMZWZ0J31cbiAgICAgICAgICAgICAgICBpY29uU2l6ZT17MzB9XG4gICAgICAgICAgICAgICAgb25DbGljaz17bW92ZUxlZnR9XG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICAgIDxkaXYgY3NzPXtTdHlsZXMuYXJyb3dCdXR0b25Db250YWluZXIoJ3JpZ2h0Jyl9PlxuICAgICAgICAgICAgICA8SWNvbkJ1dHRvblxuICAgICAgICAgICAgICAgIGFyaWFMYWJlbD1cIm5leHQgc3RlcFwiXG4gICAgICAgICAgICAgICAgY29sb3I9XCJpY29uLXByaW1hcnlcIlxuICAgICAgICAgICAgICAgIGRpc2FibGVkPXshY2FuTW92ZVJpZ2h0fVxuICAgICAgICAgICAgICAgIGljb249eydhcnJvd1NtYWxsUmlnaHQnfVxuICAgICAgICAgICAgICAgIGljb25TaXplPXszMH1cbiAgICAgICAgICAgICAgICBvbkNsaWNrPXttb3ZlUmlnaHR9XG4gICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICA8L2Rpdj5cbiAgICAgICAgICA8L0ZyYWdtZW50PlxuICAgICAgICApfVxuICAgICAgICA8dWxcbiAgICAgICAgICBjc3M9e1N0eWxlcy5pdGVtcyhpdGVtT2Zmc2V0KX1cbiAgICAgICAgICBvblRvdWNoRW5kPXtzdG9wRHJhZ2dpbmd9XG4gICAgICAgICAgb25Ub3VjaFN0YXJ0PXtzdGFydERyYWdnaW5nfVxuICAgICAgICAgIHJlZj17Y2Fyb3VzZWx9XG4gICAgICAgID5cbiAgICAgICAgICB7Lyogb25seSByZW5kZXIgY2hpbGRyZW4gaWYgdGhleSBoYXZlIGEgd2lkdGggKi99XG4gICAgICAgICAge2Nhcm91c2VsQ2hpbGRXaWR0aCA+IDAgJiYgY2hpbGRyZW5XaXRoSWR9XG4gICAgICAgIDwvdWw+XG4gICAgICAgIDxkaXYgY3NzPXtTdHlsZXMuaW5kaWNhdG9yQ29udGFpbmVyKHNpemUuaXNTbWFsbCl9PlxuICAgICAgICAgIHtzaG91bGRTaG93SW5kaWNhdG9yICYmIChcbiAgICAgICAgICAgIDxJbmRpY2F0b3JcbiAgICAgICAgICAgICAgYXJpYUxhYmVsPVwic2VsZWN0IGEgc3RlcFwiXG4gICAgICAgICAgICAgIGNvbG9yPVwiZ3JheVwiXG4gICAgICAgICAgICAgIC8vIHdlJ3ZlIGNoYW5nZWQgdG8gc2hvd2luZyB0d28gaXRlbXMgYXQgYSB0aW1lLFxuICAgICAgICAgICAgICAvLyBzbyBsZXQncyBub3QgYWxsb3cgdGhlIHVzZXIgdG8gdGFiIHBhc3Qgd2hhdCdzIHVzZWZ1bC5cbiAgICAgICAgICAgICAgY291bnQ9e251bWJlck9mSXRlbXMgLSAoIXNpemUuaXNTbWFsbCA/IDEgOiAwKX1cbiAgICAgICAgICAgICAgbm91bj1cInN0ZXBcIlxuICAgICAgICAgICAgICBvbkNoYW5nZUluZGV4PXtpbmRleCA9PiBnb1RvSW5kZXgoaW5kZXgpfVxuICAgICAgICAgICAgICBzZWxlY3RlZEluZGV4PXtjdXJyZW50SW5kZXh9XG4gICAgICAgICAgICAvPlxuICAgICAgICAgICl9XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9kaXY+XG4gICAgPC9GcmFnbWVudD5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IENhcm91c2VsO1xuIl19 */");
  },
  indicatorContainer: isSmall => /*#__PURE__*/css({
    alignItems: 'center',
    display: 'flex',
    height: isSmall ? 70 : 90,
    justifyContent: 'center',
    margin: '0 auto',
    position: 'relative'
  }, process.env.NODE_ENV === "production" ? "" : ";label:Styles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
});

const Carousel = ({
  children,
  onChange,
  renderHeading
}) => {
  var _carouselContainer$cu, _carouselContainer$cu2;

  const [windowWidth] = useWindowSize();
  const size = useSize();
  const [itemOffset, setItemOffset] = useState(0);
  const [margin, setMargin] = useState(0);
  const [carouselChildWidth, setCarouselChildWidth] = useState(0);
  const carousel = useRef(null);
  const carouselContainer = useRef(null);
  const numberOfItems = React__default.Children.count(children);
  const parentWidth = ((_carouselContainer$cu = carouselContainer.current) === null || _carouselContainer$cu === void 0 ? void 0 : (_carouselContainer$cu2 = _carouselContainer$cu.parentElement) === null || _carouselContainer$cu2 === void 0 ? void 0 : _carouselContainer$cu2.getBoundingClientRect().width) || 0;
  const {
    canMoveLeft,
    canMoveRight,
    currentIndex,
    moveRight,
    moveLeft,
    goToIndex
  } = useCarouselPagination({
    numberOfItems
  });
  const previousIndex = usePrevious(currentIndex);
  const {
    startDragging,
    stopDragging,
    isDragging
  } = useDraggingPagination({
    moveRight,
    moveLeft
  });
  const childrenWithId = useMemo(() => React__default.Children.map(children, (child, i) => {
    const isNext = currentIndex === i - 1;
    const isPrevious = currentIndex === i + 1;
    const isCurrent = currentIndex === i;
    const opacity = isPrevious || currentIndex === i - 2 ? '.6' : isCurrent || isNext ? '1' : '0';
    const visibility = isNext || isPrevious || isCurrent || currentIndex === i - 2 ? 'visible' : 'hidden';
    return /*#__PURE__*/React__default.cloneElement(child, {
      style: {
        visibility,
        opacity,
        transition: 'opacity .3s, visibility .3s',
        transitionTimingFunction: 'ease-in-out',
        width: carouselChildWidth,
        margin: `0 ${margin}px`,
        display: 'flex',
        justifyContent: 'center'
      }
    });
  }), [carouselChildWidth, children, currentIndex, margin]); // see if we can calculate sizes before painting

  useLayoutEffect(() => {
    if (carouselContainer.current !== null && carousel.current !== null && windowWidth && !isDragging) {
      const cardWidthAsPercentageWidthOfContainer = size.isSmall ? 0.8 : 0.28;
      const targetChildWidth = parentWidth * cardWidthAsPercentageWidthOfContainer;
      const marginPercentage = size.isSmall ? 1 : 0.05; // calculate the remaning space we have in the container
      // after the child width has been calculated, get the desired margin percentage size,
      // and divide by 2 to get margin per side

      const targetChildMargin = (parentWidth - targetChildWidth) * marginPercentage / 2; // the first two cards should be just left and right of center
      // so get the center of the parent container by dividing by 2,
      // then subtract the margin

      const startingOffset = size.isSmall ? 0 : parentWidth / 2 - (targetChildWidth + targetChildMargin * 2); // depending on which card we're on, calculate the number of points
      // to move the content left or right

      const offset = startingOffset - (targetChildWidth + targetChildMargin * 2) * currentIndex;
      setItemOffset(offset);
      setMargin(targetChildMargin);
      setCarouselChildWidth(targetChildWidth);
    }
  }, [carousel, carouselContainer, currentIndex, isDragging, parentWidth, size.isSmall, windowWidth]); // notify of a change in index

  useEffect(() => {
    if (onChange) {
      onChange(currentIndex, previousIndex);
    }
  }, [currentIndex, onChange, previousIndex]);
  const shouldShowIndicator = size.isSmall || numberOfItems > 2;
  return isolateComponent(Fragment, null, typeof renderHeading === 'function' && renderHeading({
    currentIndex,
    numberOfItems
  }), isolateComponent("div", {
    css: Styles.root,
    ref: carouselContainer
  }, !size.isSmall && numberOfItems > 2 && isolateComponent(Fragment, null, isolateComponent("div", {
    css: Styles.arrowButtonContainer('left')
  }, isolateComponent(IconButton, {
    ariaLabel: "previous step",
    color: "icon-primary",
    disabled: !canMoveLeft,
    icon: 'arrowSmallLeft',
    iconSize: 30,
    onClick: moveLeft
  })), isolateComponent("div", {
    css: Styles.arrowButtonContainer('right')
  }, isolateComponent(IconButton, {
    ariaLabel: "next step",
    color: "icon-primary",
    disabled: !canMoveRight,
    icon: 'arrowSmallRight',
    iconSize: 30,
    onClick: moveRight
  }))), isolateComponent("ul", {
    css: Styles.items(itemOffset),
    onTouchEnd: stopDragging,
    onTouchStart: startDragging,
    ref: carousel
  }, carouselChildWidth > 0 && childrenWithId), isolateComponent("div", {
    css: Styles.indicatorContainer(size.isSmall)
  }, shouldShowIndicator && isolateComponent(Indicator, {
    ariaLabel: "select a step",
    color: "gray" // we've changed to showing two items at a time,
    // so let's not allow the user to tab past what's useful.
    ,
    count: numberOfItems - (!size.isSmall ? 1 : 0),
    noun: "step",
    onChangeIndex: index => goToIndex(index),
    selectedIndex: currentIndex
  }))));
};

export { Carousel, MOCK_SHARED_ZAP, getInviteOnlyApps, observeInView, pluralize, usePublicZapWithServices, useSuggestedZapTemplates, useZTFeatures };
